export default {"src":"/_next/static/media/Filter.92975034.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};